import {
  ToggleButton,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  alignItems: "center",
  backgroundColor: "#f4f4f7",
  backgroundImage: `linear-gradient(to bottom, ${theme.colours.uIGrey.light._5}, ${theme.colours.uIGrey.light._10})`,
  borderRadius: "9px",
  border: "1px solid #d1d1d6",
  display: "inline-flex",
  height: "32px",
  padding: "3px",

  [`& .${toggleButtonGroupClasses.grouped}`]: {
    border: "none",
    borderRadius: "6px",
    color: "#3a3a3c",
    height: "26px",
    padding: "6px 16px",
    textTransform: "none",
    whiteSpace: "nowrap",
    width: "100px",
  },

  [`& .${toggleButtonGroupClasses.selected}`]: {
    backgroundImage: `linear-gradient(to bottom, ${theme.colours.uIGrey.light._30}, ${theme.colours.uIGrey.light._5})`,
    border: `1px solid ${theme.colours.uIGrey.light._15}`,
    color: "#1c1c1e !important",
  },
}));

export const BookmarkFilter = ({
  selectedFilter,
  setSelectedFilter,
}: {
  selectedFilter: string;
  setSelectedFilter: (filter: string) => void;
}) => {
  const handleFilterChange = (
    _: React.MouseEvent<HTMLElement>,
    newFilter: string | null,
  ) => {
    if (newFilter !== null) {
      setSelectedFilter(newFilter);
    }
  };

  return (
    <StyledToggleButtonGroup
      value={selectedFilter}
      onChange={handleFilterChange}
      exclusive
    >
      <ToggleButton value="all">All items</ToggleButton>
      <ToggleButton value="publications">Publications</ToggleButton>
      <ToggleButton value="frj_articles">FRJ articles</ToggleButton>
    </StyledToggleButtonGroup>
  );
};
